let api = {
    getPublicKey:`/api/auth/getPubKey`,
    login: `/api/auth/login`,
    verify:`/api/auth/verify`,
    validCode:`/api/auth/validCode`,
    forgetPwd:`/api/auth/forgetPwd`,
    refreshToken: `/api/auth/refreshToken`,
    sendCode:`/api/auth/sendCode`,
    telepinMobileDoLogin:`/api/auth/doMobileLogin`,
    getMenuList:`/api/menu/queryMenuListByDetailId`,
    userList: `/api/userManagement/queryUserList`,
    getBalanceList: `/api/balance/getList`,
    getTransactionList: `/api/tran/getTransactionList`,
    getAdminTransactionList: `/api/tran/getAdminTransactionList`,
    doExport: `/api/tran/doExport`,
    getCounterList: `/api/counter/getList`,
    changeWalletStatus: `/api/counter/changeWalletStatus`,
    saveAndUpdateUser: `/api/userManagement/saveAndUpdateUser`,
    deleteUser: `/api/userManagement/deleteUser`,
    createIssue:`/api/req/createIssue`,
    queryReqList:`/api/req/queryReqList`,
    queryReqDetail:`/api/req/queryReqDetail`,
    createReply:`/api/req/createReply`,
    queryIssueList:'/api/req/queryIssueList',
    uploadFile:`/api/file/uploadOne`,
    updateStatus:`/api/req/updateIssue`,
    menuList:`/api/menu/queryMenuList`,
    editMenu: `/api/menu/editMenu`,
    saveAndUpdateMenu: `/api/menu/saveAndUpdateMenu`,
    delMenu:`/api/menu/deleteMenu`,
    queryParentList:`/api/menu/queryParentList`,
    queryALLMenu:`/api/menu/queryALLMenu`,
    queryRoleMenu:`/api/menu/queryRoleMenu`,
    updateRoleMenuList:`/api/menu/updateRoleMenuList`,
    queryDictList:`/api/dict/queryDictByType`,
    saveAndUpdateDict:`/api/dict/saveAndUpdateDict`,
    deleteDict:`/api/dict/deleteDict`,
    updatePwd:`/api/userManagement/updatePwd`,
    telepinDoLogin:`/api/telepin/doLogin`,
    merchantList:`/api/merchantManagement/queryMerchantList`,
    saveAndUdtMerchant:`/api/merchantManagement/saveAndUdtMerchant`,
    deleteMerchant: `/api/merchantManagement/deleteMerchant`,
    queryAllMerchant: `/api/userManagement/queryAllMerchant`,
    queryAllRole: `/api/userManagement/queryAllRole`,
    resetQRCode: `/api/userManagement/resetQRCode`,
    removePrivilege: `/api/telepin/removePrivilege`,
    //addMerchant: `/api/merchantManagement/addMerchant`,
    initHomePageData: `/api/home/initHomePageData`,
    getMenuListByMobile:`/api/menu/queryMenuListByMobile`,
    telepinRequestTAC:`/api/telepin/sendOTP`, 
    telepinVerifyTAC:`/api/telepin/verifyOTP`, 
    telepinChangePwd:`/api/telepin/changePassword`, 
    telepinChangeSelfPwd:`/api/telepin/changePassword`, 
};

export default api;